import { Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IOverlayServiceToken, IOverlayService } from './overlay-service.interface';

@Injectable({
  providedIn: 'root'
})
export class OverlayService implements IOverlayService {
  private isOverlayVisibleSource: BehaviorSubject<boolean>;
  private isOverlayVisibleChange: Observable<boolean>;
  private isOverlayVisible: boolean;

  public constructor() {
    this.isOverlayVisible = false;
    this.isOverlayVisibleSource = new BehaviorSubject<boolean>(this.isOverlayVisible);
    this.isOverlayVisibleChange = this.isOverlayVisibleSource.asObservable();
  }

  public isOverlayVisibleSet(shouldShowOverlay: boolean): void {
    let overlayVisibilityChanged = this.isOverlayVisible != shouldShowOverlay;
    if (overlayVisibilityChanged) {
      this.isOverlayVisible = shouldShowOverlay;
      this.isOverlayVisibleSource.next(shouldShowOverlay);
    }
  }

  public isOverlayVisibleGet(): boolean {
    return this.isOverlayVisible;
  }

  public isOverlayVisibleChangeGet(): Observable<boolean> {
    return this.isOverlayVisibleChange;
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OverlayServiceProvider: Provider[] = [
  { provide: IOverlayServiceToken, useExisting: OverlayService }
];
